import styled from 'styled-components'
import axios from "axios"
import {baseURL} from "../../services/authentication.js"
import {useState,useEffect} from "react";
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';




const Container=styled.div`
	border: 1px solid #f91318;
	margin:25px;
	border-radius: 8px;
	height:150px;
	color:#ea0006;
	display:flex;
	flex-direction:column;
	overflow:hidden;
	align-items:center;
	justify-content:space-between

 `;




let TituloDnager=styled.div`
	width:100%;
	display:flex;
	justify-content:center;
	background-color:#efa0a3
`;



 export default  function DeleteRuta(){
 	const [rutas,setRutas]=useState([]);
	let [send,setSend]=useState(true)


 	useEffect(()=>{
 		axios(baseURL+"/rutas")
		.then(datos=>datos.data)
		.then(datos=>setRutas(datos));	
		

 	},[])

 	let deleteRuta=async()=>{ 				
				let idRuta=document.getElementById("idRuta").value;
				await axios.delete(baseURL+'/rutas',{data:{id:idRuta}})
			 		.then( res=>{ alert("ruta correctamente borrada" ) } )
			 		.catch((err) => (console.log(err)));
 	}
 




 	return(
 		<Container>
				<TituloDnager>DANGER ZONE</TituloDnager>
 				<div>Delete Ruta Ruta</div>
 				<select id="idRuta" disabled={send}>
 						<option value="" disabled selected>selecionar ruta</option>
 						{rutas?rutas.map(ele=><option key={ele.ID+ele.name} value={ele.ID}>{`${ele.ID} - ${ele.name}`}</option>):null}		 		
 				</select>
 				<Button  variant="contained" loadingPosition="start"  sx={{marginBottom:"10px"}} startIcon={<DeleteIcon />} loading={send} onClick={deleteRuta}>eliminar</Button>

 		</Container>


 		)
 }